/**
 * The platforms a page link can be on that Link in Bio draws with their own
 * glyph, by the link's host. A link on one shows that glyph instead of a
 * site favicon, which such sites rarely let another page load.
 */
const LINK_BRANDS = [
  ["instagram", /(^|\.)instagram\.com$/],
  ["tiktok", /(^|\.)tiktok\.com$/],
  ["facebook", /(^|\.)(facebook|fb)\.com$/],
  ["youtubeMusic", /^music\.youtube\.com$/],
  ["youtube", /(^|\.)(youtube\.com|youtu\.be)$/],
  ["x", /(^|\.)(twitter|x)\.com$/],
  ["spotify", /^open\.spotify\.com$/],
  ["appleMusic", /^(music|itunes)\.apple\.com$/],
  ["soundcloud", /(^|\.)soundcloud\.com$/],
  ["bandcamp", /(^|\.)bandcamp\.com$/],
  ["beatport", /(^|\.)beatport\.com$/],
  ["deezer", /(^|\.)deezer\.com$/],
  ["tidal", /(^|\.)tidal\.com$/],
  ["audiomack", /(^|\.)audiomack\.com$/],
  ["shazam", /(^|\.)shazam\.com$/],
  ["patreon", /(^|\.)patreon\.com$/],
] as const;

export type LinkBrand = (typeof LINK_BRANDS)[number][0];

/** The platform `url` is on, for its glyph; null for any other link. */
export function linkBrandOf(url: string): LinkBrand | null {
  let host: string;
  try {
    host = new URL(url).hostname.toLowerCase().replace(/^www\./, "");
  } catch {
    return null;
  }
  return LINK_BRANDS.find(([, hosts]) => hosts.test(host))?.[0] ?? null;
}
